import { ArticleClass } from 'shared/models/legacy';
import { useAtomValue } from 'jotai';
import { FC } from 'react';
import { $CurrentAvailableDiscoverDataOrNull } from '@discover/shared/atom';
import { $RenderConfig } from '@lemon8/web-app-shared/atom';

export const FirstArticleCardPreload: FC = () => {
  const { isSteamingSSR } = useAtomValue($RenderConfig);
  const data = useAtomValue($CurrentAvailableDiscoverDataOrNull);

  if (isSteamingSSR || !data) {
    return null;
  }

  const article = data.article.items[0];

  if (!article) {
    return null;
  }

  let images: string[] = [];
  if (article.articleClass === ArticleClass.GALLERY) {
    images = article.imageList.map((image) => image.url);
  } else {
    images = [article.largeImage.url];
  }

  return (
    <>
      {images.map((image) => (
        <link key={image} rel="preload" href={image} as="image" />
      ))}
    </>
  );
};
